/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

import modulePaymentRequest from "./paymentRequest/modulePaymentRequest";
import customerModule from "./customers/moduleCustomer";
import merchantModule from "./merchant/moduleMerchant";
import s3Service from "./s3Service/moduleS3Service";
import legalsModule from "./legals/moduleLegal";

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    paymentRequest: modulePaymentRequest,
    customer: customerModule,
    merchant: merchantModule,
    s3ServiceModule: s3Service,
    legals: legalsModule,
  },
  strict: process.env.NODE_ENV !== "production"
});
